import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import i18n from 'shared/lib/i18n';

import GlobalPersonSearchComponent from './GlobalPersonSearchComponent';

import {
  ADMIN_INVITE_RESENT,
  ADMIN_REMOVE_REQUESTED,
  SET_MODAL_TYPE,
} from '../../actionConstants';
import {
  clearRegisteredUsersCount,
  getRegisteredAllCount,
} from '../Person/actions';
import { getPersons, onWipePersonData } from './actions';

import { getTodayCount } from '../../utils';

import apiClient from '../../apiClient';
import { CONFIRM } from '../Modal/modalTypes';

const LIST_KEY = 'admin-users';

const removeAdminUser = (dispatch, adminId) => {
  dispatch({
    type: ADMIN_REMOVE_REQUESTED,
    payload: apiClient.admin.remove(adminId),
    successMessage: i18n.t('user.adminRemoved'),
    adminId,
    callback: () => {
      getPersons(dispatch, {}, { isGlobalPersonSearch: true });
    },
  });
};

const GlobalPersonSearchContainer = (props) => {
  const { onGetPersons, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetPersons(queryParams);
  };
  return <GlobalPersonSearchComponent {...props} onExport={onExport} />;
};

GlobalPersonSearchContainer.propTypes = {
  onGetPersons: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { admins, usersCount, lists } = state;
  const userId = ownProps?.match?.params?.id;
  return {
    items: admins,
    listKey: LIST_KEY,
    listParams: lists?.[LIST_KEY] || {},
    usersCount: usersCount?.verified,
    userId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getItems: (params) => {
    const userId = get(ownProps, 'match.params.id', null);
    const queryParams = { ...params, id: userId };
    getRegisteredAllCount(dispatch, queryParams);
    getPersons(dispatch, queryParams, { isGlobalPersonSearch: true });
    getTodayCount(getPersons, dispatch, queryParams, {
      isGlobalPersonSearch: true,
    });
  },
  onGetPersons: (queryParams) =>
    getPersons(dispatch, queryParams, {
      isGlobalPersonSearch: true,
      isExport: true,
    }),
  onResendInvite: (adminId) => {
    dispatch({
      type: ADMIN_INVITE_RESENT,
      payload: apiClient.admin.resendInvite(adminId),
      successMessage: i18n.t('popup.inviteSent'),
    });
  },
  onRemove: (admin) => {
    // TODO:
    // on remove logic should be updated
    // in order to fetch persons and count data
    // with the correct queryParams
    const modalProps = {
      bodyText: `${i18n.t('user.deleteUser')} "${admin.firstName} ${
        admin.lastName
      }"?`,
      onConfirm: () => removeAdminUser(dispatch, admin.id),
    };
    dispatch({
      type: SET_MODAL_TYPE,
      modalType: CONFIRM,
      modalProps,
    });
  },
  onWipePersonData: (person, getItems, listParams) =>
    onWipePersonData(dispatch, person, getItems, listParams),
  onUnmount: () => clearRegisteredUsersCount(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPersonSearchContainer);
